// 웹 접수 서버 호출 (2026-10-01) — 정본: docs/계약_등록경로v2_서버_2026-10-01.md §B (B-2·B-3·B-4). 여기 없는 키는 보내지 않는다.
//  - resolveClinicWalkin({ slug })  → { ok:true, clinicName, deskReady, careAppPilot(불리언 — 덴클 케어 앱 안내 표시 여부) } | { ok:false, message } 비로그인. 플래그 clinicWalkin 필요
//  - submitClinicWalkin({ slug, name, phone(E.164), purpose, age14Checked:true, consentVersion:'walkin-1.0', consentedAt(ms), consentTextHash })
//      → { ok:true, walkinId, clinicName, dayKey, updated, expireAt }
//      허용 밖 키 → invalid-argument {code:'field-not-allowed'}. 오류 코드 전체는 utils/clinicWalkin.js walkinErrorMessage 참조
//  - listClinicWalkins({ dayKey? })  → { count, items:[{ walkinId, submittedAt, name, purpose, linked, phoneLast4, updatedAt, linkedRecordId, submitCount }], clinicId, dayKey }
//      치과 대표·직원, 플래그 무관. 기본 오늘(KST)
//  - linkClinicWalkin({ walkinId, pid })  → { ok:true, walkinId, pid, alreadyLinked }   치과 대표·직원 데스크 수동 연결(§B-5)
//      오류 not-found / failed-precondition {code:'walkin-already-linked'|'walkin-salt-missing'}
//  - issueWalkinSlug()  → { ok:true, slug, reissued }   치과 대표 본인만(직원 permission-denied). 서버가 10자 난수 생성·walkinSlugs 예약·users.walkinSlug 기록(§B-2, 10-01 밤 P2-6)
//      오류 unauthenticated / permission-denied(직원·치과 아님·미승인) / resource-exhausted(치과당 1시간 10회) / failed-precondition {code:'walkin-salt-missing'} / internal {code:'walkin-slug-exhausted'}
//      users.walkinSlug 클라이언트 updateDoc 은 rules 로 거부됨 — 반드시 이 callable 로만 발급
import { getFunctions, httpsCallable } from 'firebase/functions';

const REGION = 'asia-northeast3';
const call = (name) => httpsCallable(getFunctions(undefined, REGION), name);

export async function resolveClinicWalkin(slug) {
    const r = await call('resolveClinicWalkin')({ slug: String(slug || '') });
    return r?.data || {};
}

// 계약 B-3 허용 키만 추려 보낸다 — 화면이 키를 더 붙여도 field-not-allowed 로 거부되지 않게
const SUBMIT_KEYS = ['slug', 'name', 'phone', 'purpose', 'age14Checked', 'consentVersion', 'consentedAt', 'consentTextHash'];
export async function submitClinicWalkin(payload) {
    const body = {};
    SUBMIT_KEYS.forEach(k => { if (payload && payload[k] !== undefined) body[k] = payload[k]; });
    const r = await call('submitClinicWalkin')(body);
    return r?.data || {};
}

export async function listClinicWalkins(dayKey) {
    const r = await call('listClinicWalkins')(dayKey ? { dayKey: String(dayKey) } : {});
    return r?.data || {};
}

// QR slug 조회(2026-10-11 보안 P1-a — 서버가 walkinSlug 를 users 문서에서 비공개 문서로 옮기고 callable 로 제공 예정).
//   계약(docs/계약_케어앱_예약대기_서버_2026-10-11.md 머리 1): getClinicWalkinSlug() → {ok, slug:string|null, updatedAt, canIssue} — 대표·직원.
//   발급 뒤 users.walkinSlug 는 서버가 지운다(스냅샷으로 기다리지 말 것 — 화면은 발급 응답 slug → 이 조회 값 순).
export const WALKIN_SLUG_FN = 'getClinicWalkinSlug';
export async function getWalkinSlug() {
    const r = await call(WALKIN_SLUG_FN)({});
    const d = r?.data || {};
    const s = typeof d.slug === 'string' ? d.slug : (typeof d.walkinSlug === 'string' ? d.walkinSlug : '');
    return s.trim();
}

// QR slug 발급·재발급(둘 다 같은 호출 — 서버가 이전 예약을 지우고 새로 만든다). 본문 키 없음
export async function issueWalkinSlug() {
    const r = await call('issueWalkinSlug')({});
    return r?.data || {};
}

// 데스크 수동 연결(§B-5) — 번호·이름 불일치로 자동 연결이 안 된 접수를 명부 환자(확인 대기·정상)에 붙인다. 같은 pid 면 멱등 alreadyLinked:true
export async function linkClinicWalkin(walkinId, pid) {
    const r = await call('linkClinicWalkin')({ walkinId: String(walkinId || ''), pid: String(pid || '') });
    return r?.data || {};
}
